/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PaymentRequestsList_statusTypes$ref: FragmentReference;
declare export opaque type PaymentRequestsList_statusTypes$fragmentType: PaymentRequestsList_statusTypes$ref;
export type PaymentRequestsList_statusTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: PaymentRequestsList_statusTypes$ref,
|};
export type PaymentRequestsList_statusTypes$data = PaymentRequestsList_statusTypes;
export type PaymentRequestsList_statusTypes$key = {
  +$data?: PaymentRequestsList_statusTypes$data,
  +$fragmentRefs: PaymentRequestsList_statusTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PaymentRequestsList_statusTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '461fbd14a5710dd255f15a61088a7efa';
module.exports = node;
